import React, { Component } from 'react';
import StarRatings from 'react-star-ratings';
import axios from 'axios';
import {API_URL} from '../../constants';

export default class RateStar extends Component {

  constructor(props) {
    super(props);
        this.state = {
            resource: [],
            response: [],
            error: [],
            key: 0,
            clave: this.props.clave,
            nRecursoCodigo: this.props.nRecursoCodigo,
            nRating : 0,
            security: JSON.parse(localStorage.getItem('userBulletin'))
          }
          console.log(props);
        }

    componentDidMount() {

      var url = `${API_URL}RateUX/${this.state.nRecursoCodigo}/${this.state.security.nUsuCodigo}`;

      axios.get(url).then(response => response.data)
      .then((data) => {
        this.setState({ nRating: data.result.nValoracion });
      })
      .catch(error => {
        console.log(error);
      });
    }

    changeRating = (newRating, name) => {
      var key = this.props.nRecursoCodigo;

      var url = `${API_URL}RateUX/`;
      var formData = JSON.stringify({nRecursoCodigo: key, nUsuario: this.state.security.nUsuCodigo, nValoracion:newRating });
      axios.put(
        url,
        JSON.stringify(formData),
        { headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
          }
        }
      ).then(response => response.data)
      .then((data) => {
          this.setState({
            nRating: newRating
          });
      })
      .catch(error => {
        console.log(error);
      });


    }

    render() {
      return (
        <StarRatings
          rating={this.state.nRating}
          starRatedColor='#F60000'
          starHoverColor ='#F60000'
          changeRating={this.changeRating}
          numberOfStars={5}
          name='rating'
          starDimension='30px'
          starSpacing='2px'

        />
      );
    }
}
